import DiagnostService from "@/services/DiagnostService";
import { bool } from "yup";
//this.$store.state.user.users,current_page
export const diagnost = {
    namespace:true,
    state: {diagnosts:{},fail:bool,searchNotification:0,paramether:[] },
    actions: {
        async getListDiagnost({commit},pageNumber){
            return await DiagnostService.getlist(pageNumber).then(
                response=>{    
                    commit('setDiagnosts',response);                    
                },
                error => {
                    commit('setFailure');
                    return Promise.reject(error);
                })
        },
        async searchListDiagnost({commit},search){          
            return await DiagnostService.getSearch(search).then (
                response =>{                    
                    commit('setDiagnosts',response)
                     commit('setSearchNotify',1)
                     commit('setParamether',search)
                },
                error=>{
                    commit('setFailure')
                    return Promise.reject(error)
                }
            );
        },
        
    },
  mutations: {
    setDiagnosts(state,data){
        state.diagnosts = data
    },
    setFailure(state){
        state.fail = false
    },
    setCurrentPage(state,data){
        state.diagnosts.current_page = data
    },
    setSearchNotify(state,data){        
        state.searchNotification = data
    },
    setParamether(state,paramSearch){        
        state.paramether = paramSearch
    }
  }
};